export async function successOrUndefined(result: Promise<any>): Promise<any> {

  try {
    return await result;
  } catch (e) {
    return undefined;
  }

}
